import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  currencyAndFiltersRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  currencyContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 5
  },
  filtersButton: {
    marginBottom: 9,
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  refreshButton: {
    marginRight: 10
  },
  menuItemRight: {
    direction: 'ltr'
  }
}))

export default useStyles
